import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { map } from 'rxjs/operators';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, StageOfBusinessService, AppService } from '../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class StageOfBusiness {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-stage-of-business',
  templateUrl: './stage-of-business.component.html'
})
export class StageOfBusinessComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    stageofbusinessList: StageOfBusiness[] = []; // Table Data list
    isSubmitted = false;
    // countryAddForm: FormGroup;
    getStageofbusiness = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;
    constructor(
                public router: Router,
                private dataService:StageOfBusinessService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }
    stageofbusiness = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;

    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allStageofbusiness();
    }
  
    allStageofbusiness(){
      this.loadShow();
      this.dataService.getAllStageofbusiness()
          .pipe().subscribe(data => { 
            this.stageofbusinessList = data['stageofbusiness']; 
            this.dtTrigger.next(); // Data Table
            this.loadHide();
          });
    }
  
    open(content) {
  
      if (this.getStageofbusiness.id !=null) {
        this.getStageofbusiness.id='';
      }
      this.isSubmitted = false;
      this.stageofbusiness.name = '',
      this.stageofbusiness.description = '',
      this.stageofbusiness.is_active = 'Y';
      this.modalTitle = "Add stage of business";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.getStageofbusiness(id)
          .pipe().subscribe(data => { 
                  this.getStageofbusiness = data['stageofbusiness']; 
                  this.stageofbusiness = {
                        id:this.getStageofbusiness.id,
                        name:this.getStageofbusiness.name,                        
                        description:this.getStageofbusiness.description,
                        is_active:this.getStageofbusiness.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit stage of business";
                  this.modalReference = this.modalService.open(content);
          });
    }


  
    save(val,f){
      this.isSubmitted = true;
      if(f.form.valid) {
        this.loadShow()
        if(val.id == ''){
          this.dataService.save(this.stageofbusiness)
              .pipe().subscribe(data =>{
                if(data['status'] == 200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Stage of business saved successfully', true);
                  this.allStageofbusiness();
                } else if(data['status'] == 422){
                  this.alertService.error(data.mesg.name)
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }else{
                  this.alertService.error("errors")
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }else{
          this.dataService.stageofbusinessUpdate(this.stageofbusiness)
              .pipe().subscribe(data =>{
                if(data['status'] ==200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Stage of business updated successfully', true);
                  this.allStageofbusiness();
                }else if(data['status'] ==300){
                  this.loadHide()
                  this.alertService.error(data.mesg);
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                }
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }
      }
    }
  
    delete(id){
      if(confirm("Are you sure to delete")) {
        this.dataService.stageofbusinessDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Stage of business deleted successfully', true);
                this.allStageofbusiness();
              }else{
                this.alertService.error('Stage of business error');
              }
            },error =>{
              this.alertService.error(error);
            });
      }
    }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
    }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
